import { SectionHead, SHELL, Reveal, Mono } from "@/components/bits";

const DEMAND = ["ASSET POOLS", "TOKENIZED FUNDS", "VAULTS", "ACCOUNTING", "NAV", "COMPLIANCE", "INVESTOR INFRASTRUCTURE"];

export default function RwaThesis() {
    return (
        <section className="relative py-24 md:py-32" data-testid="rwa-thesis-section">
            <SHELL>
                <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start">
                    <div>
                        <SectionHead
                            index="08"
                            label="WHY RWA INFRASTRUCTURE MATTERS"
                            title={"THE DEMAND\nALREADY EXISTS."}
                        />
                        <Reveal>
                            <p className="text-vera-mut text-base leading-relaxed mb-5">
                                Existing RWA protocols demonstrate real, sustained demand for asset pools, tokenized funds, vaults, accounting, NAV,
                                compliance and investor infrastructure. The category is proving that real-world value can be administered onchain —
                                with discipline.
                            </p>
                        </Reveal>
                        <Reveal delay={0.08}>
                            <p className="text-vera-mut text-base leading-relaxed">
                                VERA builds on the broader evolution of tokenized real-world financial infrastructure — as an Arc-native
                                programmable-capital architecture. It is not the next any existing protocol, and it claims no connection to any of them.
                            </p>
                        </Reveal>
                        <Reveal delay={0.14}>
                            <div className="border-l-2 border-vera-gold/60 pl-6 mt-10">
                                <p className="text-vera-white/90 text-lg sm:text-xl font-medium leading-relaxed">
                                    Verification before liquidity. Structure before scale. Capital that moves.
                                </p>
                            </div>
                        </Reveal>
                    </div>
                    <div>
                        <Reveal>
                            <Mono className="text-vera-mut block mb-6">WHAT THE CATEGORY DEMANDS</Mono>
                        </Reveal>
                        <div>
                            {DEMAND.map((d, i) => (
                                <Reveal key={d} delay={i * 0.04}>
                                    <div className="flex items-center gap-6 py-4 border-b border-white/10 group" data-testid={`rwa-demand-${d.toLowerCase().replace(/\s+/g, "-")}`}>
                                        <span className="font-mono text-[10px] text-vera-gold">{String(i + 1).padStart(2, "0")}</span>
                                        <span className="font-mono text-xs tracking-[0.3em] text-vera-mut group-hover:text-white transition-colors">{d}</span>
                                        <span className="flex-1" />
                                        <span className="w-1.5 h-1.5 rotate-45 border border-vera-gold/50 group-hover:bg-vera-gold/40 transition-colors" aria-hidden="true" />
                                    </div>
                                </Reveal>
                            ))}
                        </div>
                    </div>
                </div>
            </SHELL>
        </section>
    );
}
